import React, { useState } from 'react';
import { useTranslation } from '../context/TranslationContext';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    message: '',
    captcha: ''
  });

  const [captchaCode] = useState('A3B7C2');
  const { t } = useTranslation();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (formData.captcha !== captchaCode) {
      alert('Please enter the correct CAPTCHA code.');
      return;
    }
    
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      mobile: '',
      email: '',
      message: '',
      captcha: ''
    });
  };

  return (
    <div className="contact">
      <section className="contact-hero hero-section">
        <div className="container">
          <h1>{t('contactHero')}</h1>
          <p>{t('contactDesc')}</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-form-section">
              <h2>{t('sendUsMessage')}</h2>
              <form action="https://formspree.io/f/xeorljnq" method="POST" className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">{t('fullName')} *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="mobile">{t('whatsappNumber')} *</label>
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">{t('message')} *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="form-control"
                    placeholder={t('tellUsHow')}
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-large">
                  <i className="fas fa-paper-plane"></i> {t('sendMessage')}
                </button>
              </form>
            </div>

            <div className="contact-info-section">
              <h2>{t('getInTouch')}</h2>
              
              <div className="contact-info">
                <div className="info-item">
                  <div className="info-icon">
                    <i className="ci fas fa-map-marker-alt"></i>
                  </div>
                  <div className="info-content">
                    <h3>{t('visitOffice')}</h3>
                    <p>37/2, Elumalai Gounder Vattam<br />Kandampatty, Salem-636005</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="ci fas fa-phone"></i>
                  </div>
                  <div className="info-content">
                    <h3>{t('callUs')}</h3>
                    <p>+91 9443245877</p>
                    <p>+91 9788620377</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="ci fas fa-envelope"></i>
                  </div>
                  <div className="info-content">
                    <h3>{t('emailUs')}</h3>
                    <p>ramsonfeed@gmail.com</p>
                    <p>ramsonfeedssalem@gmail.com</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <i className="ci fas fa-clock"></i>
                  </div>
                  <div className="info-content">
                    <h3>{t('businessHours')}</h3>
                    <p>Monday - Saturday: 8:00 AM - 6:00 PM</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>

              <div className="map-section">
                <h3>{t('ourLocation')}</h3>
                <div className="map-responsive">
                    <iframe
                      title="Ramson Feeds Location"
                      className='map-iframe'
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3907.566063032882!2d78.1238819!3d11.654238999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3babf10002bbc947%3A0x1bc92f5ee3a2dfa8!2sRAMSON%20FEEDS!5e0!3m2!1sen!2sin!4v1759820494089!5m2!1sen!2sin" 
                      allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="faq-section">
        <div className="container">
          <div className="section-title">
            <h2>{t('faq')}</h2>
            <p>{t('faqDesc')}</p>
          </div>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>{t('deliveryArea')}</h3>
              <p>{t('deliveryAreaAnswer')}</p>
            </div>
            
            <div className="faq-item">
              <h3>{t('bulkDiscounts')}</h3>
              <p>{t('bulkDiscountsAnswer')}</p>
            </div>
            
            <div className="faq-item">
              <h3>{t('customFormulations')}</h3>
              <p>{t('customFormulationsAnswer')}</p>
            </div>
            
            <div className="faq-item">
              <h3>{t('paymentMethods')}</h3>
              <p>{t('paymentMethodsAnswer')}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;